import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { IconButtonDirective } from './icon-button.directive';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        IconButtonDirective,
    ],
    exports: [
        IconButtonDirective,
    ],
})
export class SharedUiIconButtonModule {}
